export const useCalculateBikeSizeStore = defineStore("claculatebikesize", {
  state: () => ({
    currentTab: 'gender',
    form: {
      gender: 'male',
      unit: 'cm',
      height: null,
      inner_leg_length: null,
      product_id: null,
    },
    isLoading: false,
    isCompleted: false,
    bikeModals: [],
    bikeModel: null,
    bikes: [],
    errors: null,
  }),

  actions: {
    setTab(tab) {
      this.currentTab = tab;
    },
    clearValidation(tab) {
      if (this.errors) {
        this.errors[tab] = null
      }
    },
    async fetchBikeModals() {
      try {
        this.isLoading = true
        const { data } = await useAPI('/api/front/calculate-bike-size?type_id=1')
        this.bikeModals = data._rawValue
        this.isLoading = false
      } catch (e) {
        console.log(e)
        this.isLoading = false
      }
    },
    async fetchResults(callback) {
      try {
        const nuxtApp = useNuxtApp()
        this.isLoading = true
        const response = await nuxtApp.$api('/api/front/calculate-bike-size', {
          method: "POST",
          body: this.form
        })
        this.bikeModel = response
        this.isCompleted = true
        this.isLoading = false
        callback && callback()
      } catch (e) {
        console.log(e)
        this.errors = e._data.errors
        this.isLoading = false
      }
    },
    updateForm(key, value) {
      this.form[key] = value
    },
    hasCompleted(value) {
      this.isCompleted = value
    },
  },
});